import { addDays, fromUnixTime, isValid as isValidDate } from 'date-fns';
import coverImage from 'img/welcome/attachesWelcomeCover.png';
import React, { useMemo, useRef, VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { isDialogVisible } from 'reactApp/modules/dialog/dialog.selectors';
import { getFeatureShowRepeatingAttaches } from 'reactApp/modules/features/features.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';

export interface IWelcomeAttachesRepeatingProps {
    onClose?: () => void;
    onShow?: () => void;
    onAccept?: () => void;
}

const LOCAL_STORAGE_KEY = 'last_welcome_attaches_repeating_show';

export const WelcomeAttachesRepeating: VFC<IWelcomeAttachesRepeatingProps> = ({ onClose, onShow, onAccept }) => {
    const isShown = useRef(false);
    const isAnyDialogVisible = useSelector(isDialogVisible);
    const featureEnabled = useSelector(getFeatureShowRepeatingAttaches);
    const dispatch = useDispatch();

    const needToShow: boolean = useMemo(() => {
        if (isShown.current) {
            return true;
        }
        if (!featureEnabled || isAnyDialogVisible) {
            return false;
        }

        const localStorageValue = dispatch(UserStorageActions.get(LOCAL_STORAGE_KEY)) as unknown as null | string;
        const lastShowTime = localStorageValue ? fromUnixTime(parseInt(localStorageValue) / 1000) : null;

        if (!lastShowTime) {
            return true;
        }

        return !isValidDate(lastShowTime) || Date.now() >= addDays(lastShowTime, featureEnabled?.days || 90).getTime();
    }, [dispatch, featureEnabled, isAnyDialogVisible]);

    return needToShow ? (
        <WhatsNewDialog
            onShow={() => {
                isShown.current = true;
                onShow?.();
                dispatch(UserStorageActions.set(LOCAL_STORAGE_KEY, Date.now()));
            }}
            onClose={onClose}
            onClick={onAccept}
            closable
            primaryButtonText="Понятно"
            title="Файлы из почты"
            qaId="attachFromMail"
            text={
                <>
                    В этом разделе вложения из писем можно только просматривать и{'\u00A0'}скачивать. Удалить их можно только вместе с
                    письмом через раздел для{'\u00A0'}
                    <a target="_blank" href="/promo/quota/#cleaner" data-qa-id="cleanerLink">
                        очистки хранилища
                    </a>
                    {'\u00A0'}или в{'\u00A0'}
                    <a href="https://e.mail.ru/inbox/" target="_blank" rel="noreferrer" data-qa-id="mailLink">
                        Почте Mail.ru
                    </a>
                </>
            }
            imageUrl={coverImage}
        />
    ) : null;
};
